import React, { ReactElement } from 'react';
import { Modal, Text, ButtonGroup, Button } from '@servicetitan/design-system';
import styles from './sign-modal.less';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';
import { signatureContainer } from 'src/signature/ioc';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { SuccessPage } from './success-page';

interface SignModalProps {
    open: boolean;
    canSubmit: boolean;
    signatureInput: ReactElement;
    signatureFieldCount?: number;
    onSubmit: () => void;
    onCancel: () => void;
}

export const SignModal: React.FC<SignModalProps> = observer(
    ({ open, signatureInput, signatureFieldCount = 0, canSubmit, onSubmit, onCancel }) => {
        const { isLoading, isSubmitSuccess } = signatureContainer.get(SignModalStore)!;

        if (isSubmitSuccess) {
            return (
                <Modal size={Modal.Sizes.S} open={open} className={styles.modal}>
                    <SuccessPage onCancel={onCancel} />
                </Modal>
            );
        }

        // tslint:disable-next-line: ter-max-len
        const legalTextPart1 =
            'This document may be signed in counterparts, all of which when taken together shall constitute the contract between the contractor and the homeowner.';
        const legalTextPart2 =
            'As such, this document may be executed and thereafter transmitted by electronic means; in which case the electronic copy of the signature may be relied upon as an original, wet ink signature.';
        const legalTextMultiPlace = `Furthermore, you hereby agree that you have reviewed and approved this document,${' '}
            and you consent for your signature to be used in ${signatureFieldCount} places within.`;

        return (
            <Modal size={Modal.Sizes.S} open={open} className={styles.modal}>
                <Text className={styles.header} size={4}>
                    Sign Document
                </Text>
                <Text size={1} className={classNames('p-t-3', styles.legalText)}>
                    {legalTextPart1}
                </Text>
                <Text size={1} className={classNames('p-t-2', styles.legalText)}>
                    {legalTextPart2}
                </Text>
                {signatureFieldCount > 1 && (
                    <Text size={1} className={classNames('p-t-2', styles.legalText)}>
                        {legalTextMultiPlace}
                    </Text>
                )}
                {signatureInput}
                <ButtonGroup className="flex-row justify-content-end p-t-3">
                    <Button className="m-t-1" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        className="m-t-1"
                        primary
                        loading={isLoading}
                        disabled={!canSubmit}
                        onClick={onSubmit}
                    >
                        Agree and Submit
                    </Button>
                </ButtonGroup>
            </Modal>
        );
    }
);
